<template>
  <div class="modal-product-option">
    <sweet-modal ref="modal" overlay-theme="dark">
      <div class="modal-title">옵션 구성</div>
      <div class="modal-desc">옵션을 직접 구성하거나 옵션 템플릿에서 가져와 구성할 수 있습니다.</div>
      <div class="content" ref="content">
        <div class="box-item" v-for="(item,idx) in items" :key="`item-${idx}`">
          <div class="grid-opt">
            <div class="grid-title">옵션명</div>
            <div>
              <div class="flex-align" style="gap:8px">
                <input class="input" style="flex:1" placeholder="옵션명을 입력해주세요."
                  type="text" v-model="item.name" @keyup="e => item.name = e.target.value">
                <button class="button half is-danger" @click="clickDelete(idx)">삭제</button>
              </div>
            </div>
          </div>
          <div class="grid-opt">
            <div class="grid-title">하위 옵션</div>
            <div>
              <div v-for="(option,optIdx) in item.options" :key="`prod-option-${optIdx}`"
                class="grid-opt-child">
                <input class="input" type="text" placeholder="하위 옵션명"
                       v-model="option.name" @keyup="e => option.name = e.target.value">
                <div class="flex-align" style="gap:4px">
                  <input class="input" type="number" placeholder="추가금액"
                         v-model.number="option.price">
                  <div class="size-14">원</div>
                </div>
                <div>
                  <i v-if="optIdx>0" @click="clickDeleteOpt(item.options, optIdx)"
                    class="material-icons unselect">close</i>
                </div>
              </div>
              <div class="flex">
                <div class="flex-align unselect primary">
                  <i class="material-icons" style="font-size:15px;margin-right:4px">add</i>
                  <div class="size-13" @click="clickAddOpt(item)">하위 옵션 추가하기</div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-opt">
            <div class="grid-title">옵션종류</div>
            <lp-radio @onSelect="res => item.option_type = res.val"
                      value_name="value"
                      label_name="label"
                      :val.sync="item.option_type"
                      :data="optionType"
                      :block="true"></lp-radio>
          </div>
          <div class="flex-align" style="margin-top: 20px">
            <lp-check-bool :checked-val.sync="item.selected" :labelStyle="{fontSize: '13px', color:'#363636'}"
                           label="이 옵션을 기본 옵션으로 설정"></lp-check-bool>
            <div class="size-13 sub1">(이 옵션을 템플릿으로 저장, 신규 상품등록시 기본 옵션으로 지정됩니다.)</div>
          </div>
        </div>
      </div>
      <div class="flex-align btn-group-add">
        <button class="button is-primary" @click="clickAdd">신규 옵션 추가</button>
        <button class="button is-primary-light" @click="clickAddTemplate">템플릿 옵션 추가</button>
      </div>
      <div class="btn-group-justify-end" style="padding-top:28px">
        <button class="button is-light" @click="clickCancel">취소</button>
        <button class="button is-primary" @click="clickAccept">저장</button>
      </div>
    </sweet-modal>
    <div class="template-modal">
      <sweet-modal ref="templateModal" overlay-theme="light">
        <div class="modal-title">옵션 템플릿 불러오기</div>
        <div>
          <div class="item-template" v-for="(item,idx) in optionTemplates" :key="`opt-template-${idx}`"
              @click="clickTemplate(item)">{{ item.label }}</div>
        </div>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
  import {SweetModal} from "sweet-modal-vue";
  import uuidv4 from 'uuid/v4';
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpRadio from "../../../module/common/LpRadio";

  export default {
    name: 'ModalProductOption',
    components: {
      LpRadio,
      LpCheckBool,

      SweetModal
    },
    props: {
      prod: {
        type: Object
      },
      selectors: {
        type: Array
      }
    },
    data() {
      return {
        items: [],
        optionType: [
          { label: '필수 선택 옵션', value:0, tip:'상품 주문 시 반드시 선택해야 하는 상품 속성 성격의 옵션입니다.'},
          { label: '추가 옵션', value:1, tip:'상품 주문 시 추가 주문할 수 있는 성격의 옵션입니다.'}
        ],
        optionTemplates: [],
        selectorStocks: []
      }
    },
    created() {
      this.getSelectorTemplate();
    },
    methods: {
      open() {
        setTimeout(() => {
          this.init();
          this.$refs.modal.open();
        }, 100)
      },

      init() {
        let items = this.cloneItem(this.selectors);
        if(items !== undefined) {
          this.items = items;
        } else {
          this.items = [];
        }
      },
      getSelectorTemplate() {
        this.$axios.get(this.getUrl('product/selector')).then(res => {
          this.optionTemplates = res.data.filter(item =>
            item.categorys.length === 0 ||
            item.categorys.some(i =>
              (i.category1 === this.prod.category1_id && !i.category2) ||
              (i.category2 === this.prod.category2_id && !i.category3) ||
              (i.category3 === this.prod.category3_id))
          ).map(item => {
            Object.assign(item, {
              stock: 0,
              add: 0,
              enable_stock: true,
              uuid: uuidv4()
            })
            return item;
          })
        });
      },
      clickAddTemplate() {
        this.$refs.templateModal.open();
      },
      clickAdd() {
        this.items.push({
          id:0,
          name:'기본 옵션',
          type:0,
          selected: false,
          required: false,
          option_type: 0,
          stock_using: false,
          minimum: 1,
          maximum: 99,
          options: [
            {
              uuid: uuidv4(),
              id:0,
              name: '옵션',
              price: 0,
              add: 0,
              stock: 0,
              files:[],
              download_count: 0,
              download_period: 3,
              desc: '',
              enable_stock: true
            }
          ]
        });
        this.scrollNewItem();
      },
      scrollNewItem() {
        this.$nextTick(() => {
          this.$refs.content.scrollTop = 1000000;
        });
      },
      clickAddOpt(item) {
        item.options.push({
          uuid: uuidv4(),
          id:0,
          name: '옵션',
          price: 0,
          add: 0,
          stock: 0,
          files:[],
          download_count: 0,
          download_period: 3,
          desc: '',
          enable_stock: true
        });
      },
      clickDelete(idx) {
        removeIndex(this.items, idx);
      },
      clickDeleteOpt(opts, optIdx) {
        removeIndex(opts, optIdx);
      },
      clickCancel() {
        this.$refs.modal.close();
      },
      clickAccept() {
        this.$emit('selector', this.cloneItem(this.items));

        // SelectorStocks 구성하여 반환
        this.selectorStocks = [];
        // 속성 옵션
        let propOptions = findArray(this.items, 'option_type', 0);
        if(propOptions.length>0) {
          this.opt([], propOptions, 0);
        }
        // 추가 옵션
        let addOptions = findArray(this.items, 'option_type', 1);
        for(let i=0; i<addOptions.length; i++) {
          for(let j=0; j<addOptions[i].options.length; j++) {
            let item = addOptions[i].options[j];
            item.minimum = 1;
            item.maximum = 99;
            this.selectorStocks.push({
              option_type: 1,
              options: [item],
              name: item.name,
              price: item.price,
              enable_stock: true,
              add: 0,
              stock: 10,
              ordered_count: 0,
              addCount: 0,
              stockCount: 0,
            });
          }
        }

        this.$emit('selectorStocks', this.cloneItem(this.selectorStocks));
        this.$refs.modal.close();
      },

      opt(str, all, cur) {
        for(let i=0; i<all[cur].options.length; i++) {
          let item = all[cur].options[i];
          item.minimum = 1;
          item.maximum = 99;
          let arr = this.cloneItem(str);
          arr.push(item);
          if(cur === all.length-1) {
            let name = '';
            let price = 0;
            arr.forEach(arr_item => {
              if(name !== '') name += ' x ';
              name += arr_item.name;
              price += parseInt(arr_item.price);
            });
            this.selectorStocks.push({
              option_type: 0,
              options: arr,
              name: name,
              price: price,
              enable_stock: true,
              add: 0,
              stock: 0,
              ordered_count: 0,
              addCount: 0,
              stockCount: 0,
            });
          } else {
            // 재귀호출
            this.opt(arr, all, cur+1);
          }
        }
      },

      clickTemplate(item) {
        item = this.cloneItem(item);
        Object.assign(item, {
          id: 0,
          selected: false,
          stock_using: false,
          minimum: 1,
          maximum: 99,
          options: item.options.map(i => {
            i.uuid = uuidv4();
            i.id = 0;
            return i;
          })
        });
        this.items.push(item);
        this.$refs.templateModal.close();
        this.scrollNewItem();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .modal-product-option
    color #363636

  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .modal-desc
    font-size 14px
    margin-bottom 28px

  .btn-group-add
    gap 12px
    button
      width 120px

  .is-danger
    background-color #ff0000

  .box-item
    background-color #f5f5f5
    border-radius 4px
    padding 20px
    margin-bottom 16px
  .box-item:last-child
    margin-bottom 0

  .grid-opt
    display grid
    grid-template-columns 120px 1fr
    grid-gap 8px
    color #363636
    margin-bottom 20px
  .grid-opt:last-child
    margin-bottom 0
  .grid-title
    font-size 14px
    height 32px
    line-height 32px

  .sub1
    color #787878

  .grid-opt-child
    display grid
    grid-template-columns 1fr 190px 20px
    grid-gap 12px
    align-items center
    margin-bottom 12px
    i
      font-size 19px
      color #989898


  .item-template
    border 1px solid #dddddd
    border-radius 4px
    padding 10px
    background-color white
    cursor pointer
  .item-template:hover
    background-color #f5f5f5

  .btn-group-justify-end
    button
      width 76px

</style>
<style lang="stylus">
  .modal-product-option
    .sweet-modal.is-alert
      width 780px
      max-height 96vh
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px

    .content
      max-height calc(95vh - 295px)
      overflow-y auto
      margin-bottom 28px

  .template-modal
    .sweet-modal.is-alert
      width 467px
      max-height 90vh
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 32px 32px
</style>
